/* eslint-disable @glovo/custom-rules/no-console */
export const perseusSDK = {
  track(event: unknown) {
    console.log('[perseusSDK] Emitting perseus event', event)
  },
  init() {
    //
  },
}
